import PropTypes from 'prop-types';
import ServiceType from "./components/ServiceType";
import { jsx as _jsx } from "react/jsx-runtime";
const ServiceTypes = _ref => {
  let {
    iconColor = 'purple',
    serviceTypes = []
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: "text-sm max-w-9/10"
    // replace when we upgrade tailwind
    ,
    style: {
      columns: '280px 3'
    },
    children: serviceTypes.map(st => /*#__PURE__*/_jsx(ServiceType, {
      iconColor: iconColor,
      level: 0,
      serviceType: st,
      showIcon: true
    }, `service-type-${st.code}`))
  });
};
ServiceTypes.propTypes = {
  /** color of ServiceType icons */
  iconColor: PropTypes.string,
  /** array of serviceType objects */
  serviceTypes: PropTypes.array.isRequired
};
export default ServiceTypes;
//# sourceMappingURL=ServiceTypes.js.map